import { VideoQuality } from 'livekit-client'

export type PubQuality = 'high' | 'medium' | 'low'

/** A capable host is on full quality from the first frame; the saver only steps down on evidence. */
export const INITIAL_PUB_QUALITY: PubQuality = 'high'

/**
 * Only bandwidth counts. Chrome already adapts to CPU itself (maintain-framerate),
 * and flat bytesSent is what a dynacast pause looks like, not congestion.
 */
export function publishLimited(stats: ReadonlyArray<{ qualityLimitationReason?: string }>): boolean {
  return stats.some(({ qualityLimitationReason }) => qualityLimitationReason === 'bandwidth')
}

export function stepPublishQuality(opts: {
  current: PubQuality
  limited: boolean
  healthyTicks: number
  limitedTicks: number
}): { next: PubQuality; healthyTicks: number; limitedTicks: number } {
  const healthyTicks = opts.limited ? 0 : opts.healthyTicks + 1
  const limitedTicks = opts.limited ? opts.limitedTicks + 1 : 0

  let next = opts.current
  if (opts.current === 'high' && limitedTicks >= 2) next = 'medium'
  if (opts.current === 'medium' && limitedTicks >= 3) next = 'low'
  // 3 healthy ticks (15 s at TICK_MS) per step up: still a sustained signal.
  if (opts.current === 'low' && healthyTicks >= 3) next = 'medium'
  if (opts.current === 'medium' && healthyTicks >= 3) next = 'high'

  return next === opts.current ? { next, healthyTicks, limitedTicks } : { next, healthyTicks: 0, limitedTicks: 0 }
}

export function videoQualityFor(quality: PubQuality): VideoQuality {
  return { high: VideoQuality.HIGH, medium: VideoQuality.MEDIUM, low: VideoQuality.LOW }[quality]
}
